import apiClient from '../apiClient';
import { REPORT_SALES_URL } from '../apiUrl';

export const getReportSalesApi = (startDate, endDate) => {
  return apiClient.get(REPORT_SALES_URL(startDate, endDate));
};
